
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M61.495 11.515H8.505c-1.19 0-2.135.945-2.135 2.135v42.105a2.77 2.77 0 002.765 2.765h51.73a2.77 2.77 0 002.765-2.765V13.65c0-1.19-.945-2.135-2.135-2.135zM49.14 40.565V29.82h10.22v.77l-8.785 9.975H49.14zm-3.22 0h-6.44l6.44-7.315v7.315zM59.36 26.6h-7.595l7.595-8.645V26.6zM49.14 15.785h10.01L49.63 26.6h-.49V15.785zm-12.005 0h8.785V26.6h-8.785V15.785zm0 14.035h8.785v.98l-8.575 9.73h-.21V29.82zM23.66 40.565V29.82h9.205v1.645l-8.435 9.1h-.77zm-3.22 0h-7.7l7.7-8.365v8.365zM25.62 26.6l7.245-7.84v7.84H25.62zm7.245-10.815v.63L23.66 26.39V15.785h9.205zm-22.225 0h9.8V26.6h-9.8V15.785zm9.8 14.035l-9.8 10.64V29.82h9.8zm-9.8 13.93h9.8v1.12l-8.645 9.345h-1.19V43.75h.035zM14 54.215l6.44-7v7H14zm18.865 0H23.66V43.75h9.205v10.465zm-6.23-13.65l6.23-6.755v6.755h-6.23zm10.5 3.185h8.785v2.1l-7.35 8.365h-1.435V43.75zm3.57 10.465l5.215-5.95v5.95h-5.215zm18.655 0H49.14v-9.59l.77-.875h9.45v10.465zm-6.65-13.65l6.65-7.56v7.56h-6.65z","fill":"#27AE60"}})])
          )
        }
      }
    